/**
 * @voltxampere/ui — 4052 dual 4-channel analog mux CMOS variant (Sprint 43-6)
 *
 * Sprint 43 ADR-0063 introduced the `analog-mux-8` canonical engine
 * type. The 4052 ships two independent 4-channel mux sections sharing
 * select pins; this variant exposes a SINGLE 4-channel section as an
 * `analog-mux-8` instance with `channelCount: 8` defaulted to 8 (the
 * stamp ignores the parameter when only 4 channel pins are wired —
 * the upper 4 stay floating / ground). Future sprints may add a
 * dedicated `analog-mux-4` type with proper 4-channel pin layout.
 *
 * Reference: TI CD4052B. Dual 4-channel analog mux, 2 select pins
 * (A/B), shared INH. Vcc 3-15 V.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic4052 = {
    id: "4052",
    nameTr: "4052 (Çift 4 Kanal Analog Mux CMOS, DIP-16)",
    nameEn: "4052 (Dual 4-Channel Analog Mux CMOS, DIP-16)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "4052",
    schemaType: "analog-mux-8",
    defaultParams: {
        channelCount: 8,
        threshold: 2.5,
        enableActiveLow: true,
        rOn: 100,
        propagationDelay: 100e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-4052.js.map